// Libs
import React, { useContext, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import * as Yup from 'yup';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { aprovarDemanda, Demanda, updateDemanda } from '@app/api/demanda';

//Files

//Utils
import QuestionarioContextProvider from '@app/hooks/useQuestionario';
import StepDadosRequisicao from '../QuestionarioContratacao/telaSteps/StepDadosRequisicao';

interface Props {
  onUpdate: () => any;
  demanda: Demanda;
}

const ModalValidarDemandaGestorTecnico = ({
  onUpdate
}: Props) => {
  const [exibirModal, setExibirModal] = useState(false);
  const { demandaData } = useContext(QuestionarioContextProvider);

  const onConcordar = (values: Demanda) => {
    updateDemanda(values).then(resp => {
      if (resp.valid) {
        aprovarDemanda(values.id).then((data: any) => {
          if (data.valid) {
            setExibirModal(false);
            onUpdate();
          }
        });
      }
    });
  };

  return (
    <>
      <Tooltip title="Valida a criação desta demanda">
        <ui.Button
          id="mrn-button-modal-ModalValidarDemandaGestorTecnico-validar-open"
          type="success" title="Validar" onClick={() => setExibirModal(true)} />
      </Tooltip>
      <Modal
        title="Validar Demanda"
        width="680px"
        visible={exibirModal}
        onCancel={() => setExibirModal(false)}
        footer={null}>
        <ui.MasterDetailForm
          initialValues={demandaData}
          onSubmit={values => onConcordar(values)}
          validationSchema={Yup.object().shape({
            isEmergencial: Yup.boolean()
              .required('O campo deve ser informado'),
            isFornecedorDirecionado: Yup.boolean()
              .required('O campo deve ser informado'),
          })}
          actions={[
            <ui.Button
              id="mrn-button-modal-ModalValidarDemandaGestorTecnico-cancelar"
              key="discordarBtn" type="link" onClick={() => setExibirModal(false)}>
              Cancelar
            </ui.Button>,
            <ui.FormSubmitButton
              id="mrn-button-modal-ModalValidarDemandaGestorTecnico-validar"
              noIcon={true}
              type="primary">
              Validar
            </ui.FormSubmitButton>
          ]}>
          <ui.Widget>
            <StepDadosRequisicao />
          </ui.Widget>
        </ui.MasterDetailForm>
      </Modal>
    </>
  );
};

export default ModalValidarDemandaGestorTecnico;
